module.exports = __webpack_public_path__ + "assets/LevelInfos.4bfde9f4212c9ba763332acef3206794.xml";


//////////////////
// WEBPACK FOOTER
// ./src/resources/localizable/en-lproj/LevelInfos.xml
// module id = 1033
// module chunks = 0